// import React from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Navbar from "./Components/navbar/Navbar";
// import Footer from "./Components/Footer/Footer";
// import Home from "./Pages/Home";
// import About from "./Pages/About";
// import Contact from "./Pages/Contact";
// import Client from "./Pages/Client";
// import Carrer from "./Pages/Carrer";
// import Services from "./Pages/Services";
// // import Jobdetails from "./Components/JobDetails/Jobdetails";
// // import JobPostDetail from "./Components/JobDetails/JobPostDetail";
// import UploadArticle from "./Components/JobDetails/JobData";
// import ViewArticles from "./Components/JobDetails/JobPostDetail";
// import ArticleDetails from "./Components/JobDetails/Jobdetails";
// import Articles from "./Components/Articles+/Articlesad";
// import ArticleDetail from "./Components/Articles+/Openfile";
// import TamilTyping from "./Pages/typewriting";
// import RedirectPage from "./Components/Articles+/RedirectPage";
// import Signup from "./Components/JobDetails/Signup";
// import Login from "./Components/JobDetails/Login";
// // import Score from "./Pages/Score";
// // import Sitemap from "./sitemap";

// function App() {
//   const withLayout = (Component) => (
//     <>
//       <Navbar />
//       <Component />
//       <Footer />
//     </>
//   );

//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={withLayout(Home)} />
//         <Route path="/services" element={withLayout(Services)} />
//         <Route path="/about" element={withLayout(About)} />
//         <Route path="/contact" element={withLayout(Contact)} />
//         <Route path="/client" element={withLayout(Client)} />
//         <Route path="/career" element={withLayout(Carrer)} />
//         <Route path="/typing" element={withLayout(TamilTyping)} />
//         <Route path="/articles" element={withLayout(ViewArticles)} />
//         <Route path="/articles/:id" element={withLayout(ArticleDetails)} />
//         <Route path="/a" element={withLayout(Articles)} />
//         <Route path="/signup" element={withLayout(Signup)} />
//         <Route path="/login" element={withLayout(Login)} />
//         <Route path="/go/:id" element={withLayout(RedirectPage)} />
//         <Route path="/:id" element={withLayout(ArticleDetail)} />
//         <Route path="/upload" element={withLayout(UploadArticle)} />

//         {/* Routes without Nav bar and Footer */}
//         {/* <Route path="/score" element={<Score />} /> */}
//         {/* <Route path="/sitemap.xml" element={<Sitemap />} /> */}
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "./Components/navbar/Navbar";
import Footer from "./Components/Footer/Footer";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Client from "./Pages/Client";
import Carrer from "./Pages/Carrer"; // keep if file name is same
import Services from "./Pages/Services";
import TamilTyping from "./Pages/typewriting";

import UploadArticle from "./Components/JobDetails/JobData";
// import ViewArticles from "./Components/JobDetails/JobPostDetail";
// import ArticleDetails from "./Components/JobDetails/Jobdetails";

import Articles from "./Components/Articles+/Articlesad";
import ArticleDetail from "./Components/Articles+/Openfile";
import RedirectPage from "./Components/Articles+/RedirectPage";

import Signup from "./Components/JobDetails/Signup";
import Login from "./Components/JobDetails/Login";
import Hotel from "./Pages/Hotel";
import Mark from "./Pages/Mark";

// ✅ Layout Component
const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      {/* ✅ Toast Notification */}
      <ToastContainer position="top-right" autoClose={2000} theme="colored" />

      <Routes>
        {/* 🌐 Main Pages */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/client" element={<Layout><Client /></Layout>} />
        <Route path="/career" element={<Layout><Carrer /></Layout>} />
        <Route path="/typing" element={<Layout><TamilTyping /></Layout>} />

        {/* 📄 Articles */}
        <Route path="/articles" element={<Layout><Articles /></Layout>} />
        <Route path="/articles/:id" element={<Layout><ArticleDetail /></Layout>} />

        {/* 🔁 Redirect */}
        <Route path="/go/:id" element={<Layout><RedirectPage /></Layout>} />

        {/* 🔐 Authentication */}
        <Route path="/signup" element={<Layout><Signup /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/hotel" element={<Layout><Hotel /></Layout>} />
        <Route path="/mark" element={<Layout><Mark /></Layout>} />

        {/* 📤 Upload */}
        <Route path="/upload" element={<Layout><UploadArticle /></Layout>} />

        {/* ❌ Optional fallback */}
        {/* <Route path="*" element={<Layout><h1>404 Not Found</h1></Layout>} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;